/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} MenuInputs */

const en_menu = /** @type {(inputs: MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menu`)
};

const th_menu = /** @type {(inputs: MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เมนู`)
};

const ja_menu = /** @type {(inputs: MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メニュー`)
};

const fr_menu = /** @type {(inputs: MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menu`)
};

const es_menu = /** @type {(inputs: MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menú`)
};

const ru_menu = /** @type {(inputs: MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Меню`)
};

const zh_menu = /** @type {(inputs: MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`菜单`)
};

const vi_menu = /** @type {(inputs: MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menu`)
};

/**
* | output |
* | --- |
* | "Menu" |
*
* @param {MenuInputs} inputs
* @param {{ locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }} options
* @returns {LocalizedString}
*/
export const menu = /** @type {((inputs?: MenuInputs, options?: { locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<MenuInputs, { locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_menu(inputs)
	if (locale === "ja") return ja_menu(inputs)
	if (locale === "fr") return fr_menu(inputs)
	if (locale === "es") return es_menu(inputs)
	if (locale === "ru") return ru_menu(inputs)
	if (locale === "zh") return zh_menu(inputs)
	if (locale === "vi") return vi_menu(inputs)
	return en_menu(inputs)
});